var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-account-receieve account-main-content-mt"},[_c('receive-coins',{attrs:{"verify-account":!!this.$route.params.verify}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }